// Mirrors uspstfDownloadArgsSchema in packages/middleware/src/cpg/
// uspstf-download.runner.ts — keep the shape and default in sync.
export const DEFAULT_UNCONDITIONAL = false

export function extractUnconditional(value: unknown): unknown {
  if (typeof value === 'object' && value !== null && 'unconditional' in value) {
    return (value as Record<string, unknown>).unconditional
  }
  return undefined
}

export function validateUspstfDownloadArgs(value: unknown): string | null {
  if (typeof extractUnconditional(value) !== 'boolean') {
    return 'Unconditional must be a boolean'
  }
  return null
}
